export const commonIreland = {
  enter_your_postcode_alt: 'Enter a valid Eircode',
  postcode_in_sentence: 'Eircode',
}
